/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jahresfreibetrag1Inputs */



/**

* @param {_Field_Jahresfreibetrag1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_jahresfreibetrag1 = /** @type {((inputs?: _Field_Jahresfreibetrag1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jahresfreibetrag1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jahresfreibetrag")
});
export { _field_jahresfreibetrag1 as "_field_jahresFreibetrag" }